import { captureException, ZBError } from '@zenbusiness/application-commons-logging';

export const RESTART_PHASES = {
  CONFIRM: 'confirm',
  LOADING: 'loading',
  RESULT: 'result',
};

export const RESTART_CHANGE_TYPE = 'active';

export const RESTART_CLICKSTREAM_EVENTS = {
  back: 'restart_subscription_back',
  close: 'restart_subscription_close',
  submit: 'restart_subscription_submit',
  success: 'restart_subscription_success',
  error: 'restart_subscription_error',
  returnDashboard: 'restart_subscription_return_dashboard',
  returnSubscriptions: 'restart_subscription_return_subscriptions',
  contactUs: 'restart_subscription_contact_us',
};

export function buildRestartSubscriptionContext(subscription) {
  if (!subscription) {
    return undefined;
  }
  return {
    service: subscription.service,
    billingInterval: subscription.period,
    contractInterval: subscription.contractInterval,
    subscriptionStatus: subscription.subscriptionStatus,
  };
}

export function getRestartClickstreamProps(eventKey, subscriptionContext) {
  const elementName = RESTART_CLICKSTREAM_EVENTS[eventKey];
  if (!elementName) {
    captureException(new ZBError(`Unknown subscription restart event: ${eventKey}`));
  }
  const { service, billingInterval, contractInterval, subscriptionStatus } = subscriptionContext ?? {};
  const dynamic = {
    ...(service && { subscriptionService: service }),
    ...(billingInterval && { billingInterval }),
    ...(contractInterval && { contractInterval }),
    ...(subscriptionStatus && { subscriptionStatus }),
  };
  return {
    elementName,
    page: 'subscription_restart',
    ...(Object.keys(dynamic).length > 0 && { dynamicProperties: dynamic }),
  };
}
